import axios from 'axios'
// import Vue from 'vue'
import Qs from 'qs'

const $axios = axios.create({
    // 设置超时时间
    timeout: 5000,
    // baseURL: "http://39.100.19.70:8080",
    baseURL: "/"
    // baseURL: ""
    // baseURL: '/api'
})
// Vue.prototype.$http = axios  // vue 3 弃用
// 请求拦截器
$axios.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        return config
    },
    error => {
        return Promise.reject(error)
    }
)
// 响应拦截器
$axios.interceptors.response.use(
    response => {
        const code = response.status
        if ((code >= 200 && code < 300) || code === 304) {
            if (code == 210) {
                // try {
                //     Message(response.data)
                // } catch (e) {}
                return Promise.reject(response)
            }
            return Promise.resolve(response.data)
        } else {
            return Promise.reject(response)
        }
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    break
                case 404:
                    break;
                default:
                    console.log(error.response.data.message)
            }
        } else {
            // 请求超时或者网络有问题
            console.log(error.response.data.message)
        }
        return Promise.reject(error)
    }
)
// get，post请求方法
export default {
    post,
    get,
    registerApi
}

function post(url, data) {
    console.log(url);
    return $axios({
        method: 'post',
        url,
        data: Qs.stringify(data),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
    })
}

function get(url, params) {
    return $axios({
        method: 'get',
        url,
        params
    })
}

function registerApi(apiMap, options, apiObj) {
    for (const key in apiMap) {
        // eslint-disable-next-line no-prototype-builtins
        if (apiMap.hasOwnProperty(key)) {
            const config = apiMap[key];
            apiObj[key] = function (input_params) {
                let params = null;
                let result;
                if (config.params == '*') {
                    params = Object.assign({}, input_params)
                } else if (config.params && input_params) {
                    params = {}
                    config.params.forEach(p => {
                        params[p] = input_params[p]
                    })
                }
                let targetUrl = `${(options && options.commonPath) || ''}${config.url}`
                if (config.method == 'post') {
                    result = post(targetUrl, params)
                } else {
                    result = get(targetUrl, params)
                }
                return result;
            }
        }
    }
}
